import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";

import heroImage from "../../../../Assets/Images/whatsapp/apiservice-hero.png";
import ContactModal from "../../../../Assets/Common/ContactModal";

const HeroSection = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleGetStarted = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <>
      <section className="relative overflow-hidden bg-[#050505]">
        <div
          className="
            absolute
            inset-0
            bg-cover
            bg-[center_right]
            bg-no-repeat
          "
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        />

        <div className="absolute inset-0 bg-black/20" />

        <div
          className="
            absolute
            inset-0
            bg-gradient-to-r
            from-[#050505]/95
            via-[#050505]/65
            to-transparent
          "
        />

        <div
          className="
            absolute
            inset-0
            bg-gradient-to-b
            from-transparent
            via-transparent
            to-[#050505]/40
          "
        />

        <div
          className="
            pointer-events-none
            absolute
            left-[35%]
            top-1/2
            h-72
            w-72
            -translate-y-1/2
            rounded-full
            bg-orange-500/[0.08]
            blur-[120px]
          "
        />

        <div
          className="
            pointer-events-none
            absolute
            inset-0
            opacity-[0.06]
          "
          style={{
            backgroundImage: `
              linear-gradient(
                to right,
                rgba(255,255,255,0.15) 1px,
                transparent 1px
              ),
              linear-gradient(
                to bottom,
                rgba(255,255,255,0.15) 1px,
                transparent 1px
              )
            `,
            backgroundSize: "55px 55px",
          }}
        />

        <div
          className="
            relative
            z-10
            mx-auto
            flex
            min-h-[390px]
            w-full
            max-w-7xl
            items-center
            px-4
            py-10
            sm:min-h-[410px]
            sm:px-6
            sm:py-12
            lg:min-h-[430px]
            lg:px-8
            lg:py-14
          "
        >
          <div className="w-full max-w-3xl text-left">
            <motion.h1
              initial={{
                opacity: 0,
                y: 25,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.15,
                duration: 0.7,
              }}
              className="
                max-w-3xl
                pt-20
                font-saira
                text-3xl
                font-bold
                leading-[1.08]
                tracking-tight
                text-white
                sm:text-4xl
                md:text-5xl
                lg:text-6xl
              "
            >
              Powerful APIs For{" "}
              <span className="text-orange-500">
                Faster, Smarter
              </span>{" "}
              Business Communication.
            </motion.h1>

            <motion.p
              initial={{
                opacity: 0,
                y: 25,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.3,
                duration: 0.7,
              }}
              className="
                mt-4
                max-w-2xl
                text-xs
                leading-5
                text-white/90
                sm:mt-5
                sm:text-sm
                sm:leading-6
                md:text-base
                md:leading-7
                lg:text-lg
              "
            >
              Connect your applications with secure, scalable and
              developer-friendly APIs for WhatsApp messaging, SMS OTP
              authentication, notifications and automated business
              communication.
            </motion.p>

            <motion.div
              initial={{
                opacity: 0,
                y: 25,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.45,
                duration: 0.7,
              }}
              className="
                mt-6
                flex
                flex-col
                gap-3
                sm:mt-7
                sm:flex-row
                sm:flex-wrap
                sm:gap-4
              "
            >
              <button
                type="button"
                onClick={handleGetStarted}
                className="
                  group
                  inline-flex
                  w-full
                  items-center
                  justify-center
                  gap-2.5
                  rounded-xl
                  bg-[var(--brand-primary)]
                  px-5
                  py-3
                  text-sm
                  font-semibold
                  text-white
                  shadow-[0_8px_25px_rgba(249,115,22,0.2)]
                  transition-all
                  duration-300
                  hover:-translate-y-0.5
                  hover:bg-[var(--brand-hover)]
                  hover:shadow-[0_12px_32px_rgba(249,115,22,0.3)]
                  active:translate-y-0
                  sm:w-auto
                  sm:px-6
                  sm:py-3.5
                  sm:text-base
                "
              >
                <span>Get Started</span>

                <span
                  className="
                    flex
                    h-6
                    w-6
                    shrink-0
                    items-center
                    justify-center
                    rounded-full
                    bg-white/10
                    transition-transform
                    duration-300
                    group-hover:translate-x-1
                  "
                >
                  <ArrowRight
                    size={16}
                    strokeWidth={2.2}
                  />
                </span>
              </button>
            </motion.div>
          </div>
        </div>
      </section>

      <AnimatePresence>
        {isContactModalOpen && (
          <ContactModal
            isOpen={isContactModalOpen}
            onClose={handleCloseContactModal}
            initialService="API Services"
            initialSubService=""
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default HeroSection;